import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  pullSimple: {
    width: 100,
    height: 100,
    d: `M50,2.507C23.77,2.507,2.507,23.77,2.507,50S23.77,97.493,50,97.493S97.493,76.23,97.493,50
  		S76.23,2.507,50,2.507z M80.992,51.592c0,1.645-1.334,2.979-2.979,2.979H21.987c-1.645,0-2.979-1.334-2.979-2.979v-3.184
  		c0-1.645,1.334-2.979,2.979-2.979h56.026c1.645,0,2.979,1.334,2.979,2.979V51.592z`,
  },
});
